import React from 'react'

const IgMountBase = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={343}
    height={176}
    viewBox="0 0 343 176"
    fill="none"
    style={{ zoom: 2, width: '170px' , height:'100px' }}
    {...props}
  >
    <path
      opacity={0.4}
      d="M107.396 86.2949C113.716 90.0136 119.823 93.6068 125.837 97.1457"
      stroke="#BABEC3"
      strokeWidth={5}
      strokeLinecap="round"
    />
    <path
      opacity={0.4}
      d="M133.987 29.8926C140.676 33.8283 147.898 38.078 155.433 42.5119"
      stroke="#BABEC3"
      strokeWidth={5}
      strokeLinecap="round"
    />
    <path
      d="M182.285 131.824L183.745 132.668L185.339 131.747V130.065L188.881 128.021M187.421 128.859L188.881 129.703L190.475 128.783V127.1L194.017 125.056M192.557 125.894L194.011 126.738L195.604 125.818V124.135L199.147 122.091M161.747 143.683L163.208 144.521L164.801 143.6V141.918L168.344 139.874M166.883 140.718L168.344 141.562L169.937 140.642V138.959L173.48 136.915M172.019 137.753L173.473 138.597L175.067 137.677V135.995L178.609 133.95M177.155 134.788L178.616 135.633L180.209 134.712V133.03L183.752 130.986M197.636 122.948L199.096 123.793C208.587 118.117 216.136 111.286 216.136 95.5541V33.8905C216.136 29.0401 214.536 25.8214 211.882 24.2343L204.829 20.2093C201.445 18.1777 196.341 18.8062 190.665 22.0821L143.775 49.1524C133.642 54.9995 125.357 60.6179 125.357 78.2035V139.867C125.357 145.409 126.9 148.704 129.465 150.196L136.499 154.215C139.616 156.037 144.168 155.256 149.387 152.507V150.825L152.929 148.781M151.475 149.612L152.929 150.457L154.523 149.536V147.854L158.065 145.809M156.611 146.647L158.072 147.492L159.665 146.571V144.889L163.208 142.845"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M156.611 146.648L158.065 147.493L159.659 146.572V144.89L163.201 142.846"
      fill="white"
    />
    <path
      d="M151.475 149.62L152.928 150.458L154.522 149.537V147.855L158.064 145.811"
      fill="white"
    />
    <path
      d="M197.636 122.949L199.096 123.794C208.587 118.118 216.136 111.287 216.136 95.5488V33.8787C216.136 29.0284 214.536 25.8097 211.882 24.2226L204.829 20.1976C201.445 18.166 196.341 18.7945 190.665 22.0704L143.775 49.1471C133.642 54.9941 125.357 60.6126 125.357 78.1981V139.868C125.357 145.41 126.9 148.712 129.465 150.197L136.506 154.216C139.623 156.038 144.175 155.257 149.393 152.508V150.826L152.936 148.782"
      fill="white"
    />
    <path
      d="M177.155 134.788L178.609 135.632L180.203 134.711V133.029L183.745 130.979"
      fill="white"
    />
    <path
      d="M172.02 137.753L173.473 138.597L175.067 137.676V135.994L178.609 133.943"
      fill="white"
    />
    <path
      d="M166.883 140.719L168.337 141.563L169.93 140.643V138.96L173.473 136.916"
      fill="white"
    />
    <path
      d="M161.747 143.684L163.201 144.528L164.794 143.607V141.925L168.337 139.881"
      fill="white"
    />
    <path
      d="M192.563 125.895L194.017 126.739L195.611 125.819V124.137L199.153 122.086"
      fill="white"
    />
    <path
      d="M187.427 128.858L188.881 129.702L190.474 128.782V127.099L194.017 125.049"
      fill="white"
    />
    <path
      d="M182.291 131.823L183.745 132.667L185.338 131.747V130.064L188.881 128.014"
      fill="white"
    />
    <path
      d="M132.17 151.682C129.497 150.241 127.891 146.921 127.891 141.258V79.5878C127.891 62.0022 136.176 56.3837 146.308 50.5367L193.198 23.46C198.931 20.1524 204.074 19.5429 207.457 21.6443"
      stroke="#6B7073"
      strokeWidth={0.38}
      strokeLinejoin="round"
    />
    <path
      d="M197.959 58.0532V86.5456M134.785 153.206C132.112 151.764 130.506 148.444 130.506 142.781V81.1112C130.506 63.5256 138.791 57.9071 148.923 52.0601L195.814 24.9835C201.546 21.6758 206.689 21.0664 210.073 23.1678M211.882 24.2216C208.498 22.1901 203.394 22.8186 197.718 26.0945L150.828 53.1711C140.695 59.0182 132.41 64.6366 132.41 82.2222V143.892C132.41 149.422 133.947 152.717 136.505 154.215M152.929 148.774V150.457M158.065 145.81V147.492M163.201 142.845V144.527M168.375 139.981V141.664M173.473 136.915V138.598M178.609 133.944V135.626M183.745 130.979V132.662M188.881 128.014V129.697M194.017 125.05V126.732M199.096 122.104V123.786M148.517 77.2639C148.091 77.0417 147.825 76.5275 147.825 75.7847C147.825 74.3626 148.802 72.6485 150.009 71.9502C150.574 71.6264 151.088 71.582 151.482 71.7724"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M162.82 100.424L174.94 93.4279C176.267 92.6598 177.346 90.7679 177.346 89.2061V75.1504"
      stroke="#6B7073"
      strokeWidth={0.38}
      strokeLinejoin="round"
    />
    <path
      d="M170.089 60.1991C167.791 61.526 165.912 60.7324 165.912 58.4342V51.3746C165.912 47.1274 167.791 46.1116 170.089 44.7848L178.451 39.9535C180.749 38.6267 182.628 39.4202 182.628 41.7184M173.968 59.1326C173.442 59.1961 173.099 58.8723 173.099 57.7359V53.4569C173.099 51.5524 174.038 50.8286 175.187 50.162L181.733 46.3846C182.583 45.8958 183.32 45.5593 183.644 46.2069"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M183.644 46.2012C183.758 46.4234 183.815 46.7662 183.815 47.2614V51.5403C183.815 53.4703 182.876 54.1686 181.727 54.8352L175.188 58.6126C174.737 58.8729 174.312 59.0824 173.969 59.1269"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M147.303 76.5604C146.884 76.3318 146.624 75.8239 146.624 75.0875C146.624 73.6654 147.602 71.9513 148.808 71.253C149.373 70.9228 149.887 70.8848 150.281 71.0689"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M197.585 51.0071C197.77 51.0325 197.979 50.9817 198.201 50.8483C198.874 50.4611 199.414 49.5088 199.414 48.7216C199.414 48.4549 199.35 48.2391 199.242 48.0931M197.566 51.2166C197.566 52.4164 198.392 52.918 199.414 52.3276C200.436 51.7372 201.268 50.2833 201.268 49.0834C201.268 47.8836 200.436 47.382 199.414 47.9724C198.392 48.5629 197.566 50.0167 197.566 51.2166Z"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M209.387 44.3914C209.387 45.2294 208.809 46.2452 208.091 46.6578C207.38 47.0705 206.803 46.7213 206.803 45.8833C206.803 45.0453 207.38 44.0295 208.091 43.6169C208.803 43.2042 209.387 43.5534 209.387 44.3914Z"
      stroke="#6B7073"
      strokeWidth={0.38}
      strokeLinejoin="round"
    />
    <path
      d="M209.685 51.0816C209.685 51.2403 209.793 51.3038 209.926 51.2276C210.06 51.1451 210.168 50.961 210.168 50.8022V43.9394C210.168 42.5999 209.241 42.0412 208.098 42.7015C206.955 43.3617 206.028 44.9933 206.028 46.3328V53.1957C206.028 53.3544 206.136 53.4179 206.27 53.3417C206.403 53.2591 206.511 53.075 206.511 52.9163V46.0535C206.511 45.0187 207.222 43.7744 208.098 43.2665C208.974 42.7586 209.685 43.1903 209.685 44.2188V51.0816Z"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M208.606 44.7901C208.904 44.6124 209.145 44.7584 209.145 45.1139C209.145 45.4694 208.904 45.8948 208.606 46.0662C208.307 46.244 208.066 46.098 208.066 45.7424C208.066 45.3869 208.307 44.9616 208.606 44.7901Z"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M154.496 86.8821C154.496 83.4031 152.134 81.9366 149.233 83.6126C146.332 85.2886 143.97 89.4787 143.97 92.9577M143.964 92.9577V101.916M143.964 111.356V121.533C143.964 124.116 145.735 125.196 147.925 123.964M147.932 123.964C147.932 123.964 147.963 123.945 147.976 123.939L154.56 120.136M193.705 97.535L200.561 93.5735C202.771 92.2974 204.574 89.1422 204.574 86.5393V75.0801M204.574 68.1538V57.9707"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinejoin="round"
    />
    <path
      d="M205.374 74.668V86.0764C205.374 89.1935 203.209 92.99 200.562 94.52L193.94 98.3418M154.572 121.076L147.976 124.885C145.329 126.415 143.164 125.114 143.164 122.003V111.617"
      stroke="#6B7073"
      strokeWidth={0.38}
      strokeLinejoin="round"
    />
    <path
      d="M200.149 86.5902L144.161 118.917M204.574 57.9709C204.574 54.4919 202.212 53.0253 199.311 54.7014C196.41 56.3774 194.048 60.5674 194.048 64.0465L154.503 86.8823"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M155.29 86.0183L170.895 77.016M177.58 73.1561L193.248 64.1094"
      stroke="#6B7073"
      strokeWidth={0.38}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M200.562 93.6563L200.333 86.4824M147.977 123.939L144.161 118.917"
      stroke="#6B7073"
      strokeWidth={0.38}
      strokeMiterlimit={10}
    />
    <path d="M190.475 30.2786V31.961L194.017 29.9167V28.2344" fill="white" />
    <path
      d="M190.475 30.2786V31.961L194.017 29.9167V28.2344"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M148.23 53.4754L149.386 54.0023V55.6847L152.928 53.6405V51.9517L151.836 51.3867L148.23 53.4754Z"
      fill="white"
    />
    <path
      d="M148.23 53.4754L149.386 54.0023V55.6847L152.928 53.6405V51.9517L151.836 51.3867L148.23 53.4754Z"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M154.515 51.037L154.522 52.7194L158.064 50.6751V48.9864L156.966 48.4277L153.354 50.5101L154.515 51.037Z"
      fill="white"
    />
    <path
      d="M154.515 51.037L154.522 52.7194L158.064 50.6751V48.9864L156.966 48.4277L153.354 50.5101L154.515 51.037Z"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M158.483 47.553L159.645 48.08L159.658 49.756L163.2 47.7117V46.023L162.096 45.4707L158.483 47.553Z"
      fill="white"
    />
    <path
      d="M158.483 47.553L159.645 48.08L159.658 49.756L163.2 47.7117V46.023L162.096 45.4707L158.483 47.553Z"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M163.613 44.5945L164.769 45.1215L164.794 46.7911L168.337 44.7406V43.0582L167.226 42.5059L163.613 44.5945Z"
      fill="white"
    />
    <path
      d="M163.613 44.5945L164.769 45.1215L164.794 46.7911L168.337 44.7406V43.0582L167.226 42.5059L163.613 44.5945Z"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M168.743 41.6292L169.899 42.1561L169.93 43.8258L173.473 41.7752V40.0929L172.355 39.5469L168.743 41.6292Z"
      fill="white"
    />
    <path
      d="M168.743 41.6292L169.899 42.1561L169.93 43.8258L173.473 41.7752V40.0929L172.355 39.5469L168.743 41.6292Z"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M173.873 38.6722L175.028 39.1991L175.067 39.2118V40.8624L178.609 38.8118V37.1295L177.479 36.5898L173.873 38.6722Z"
      fill="white"
    />
    <path
      d="M173.873 38.6722L175.028 39.1991L175.067 39.2118V40.8624L178.609 38.8118V37.1295L177.479 36.5898L173.873 38.6722Z"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M180.202 36.266V37.8976L183.744 35.847V34.1646L182.608 33.625L179.002 35.7073L180.157 36.2343"
      fill="white"
    />
    <path
      d="M180.202 36.266V37.8976L183.744 35.847V34.1646L182.608 33.625L179.002 35.7073L180.157 36.2343"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M184.126 32.7483L185.288 33.2753L185.339 33.3007V34.9259L188.881 32.8817V31.1993L187.738 30.666L184.126 32.7483Z"
      fill="white"
    />
    <path
      d="M184.126 32.7483L185.288 33.2753L185.339 33.3007V34.9259L188.881 32.8817V31.1993L187.738 30.666L184.126 32.7483Z"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M194.024 28.2281L192.868 27.7012L189.256 29.7898L190.411 30.3168"
      fill="white"
    />
    <path
      d="M194.024 28.2281L192.868 27.7012L189.256 29.7898L190.411 30.3168"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M197.997 24.7422L194.385 26.8245L195.54 27.3515L195.61 27.3832V28.9957L199.153 26.9515V25.2691L197.997 24.7422Z"
      fill="white"
    />
    <path
      d="M197.997 24.7422L194.385 26.8245L195.54 27.3515L195.61 27.3832V28.9957L199.153 26.9515V25.2691L197.997 24.7422Z"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M150.282 71.0801L151.482 71.7721C151.92 71.9879 152.199 72.5085 152.199 73.264C152.199 74.6861 151.221 76.4002 150.015 77.0985C149.437 77.4287 148.91 77.4731 148.523 77.2699L147.311 76.5716"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M151.475 149.613L152.928 150.458L154.522 149.537V147.855L158.064 145.81M156.611 146.648L158.064 147.493L159.658 146.572V144.89L163.2 142.846"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M197.997 24.7422V26.4246L195.661 27.7705M192.861 27.707V29.3893L190.525 30.7352M187.725 30.6718V32.3541L185.319 33.7445M182.589 33.6365V35.3189L180.215 36.6902M177.453 36.6013V38.2837L175.079 39.655M172.317 39.5661V41.2485L169.93 42.6261M167.181 42.5309V44.2133L164.826 45.5719M162.045 45.4957V47.178L159.652 48.5557M156.909 48.4605V50.1428L154.548 51.5078M151.773 51.4252V53.1076L149.278 54.5487"
      stroke="#6B7073"
      strokeWidth={0.38}
      strokeLinejoin="round"
    />
    <path
      d="M199.153 26.9508L197.998 26.4238"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M197.959 86.5449H204.574"
      stroke="#6B7073"
      strokeWidth={0.38}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M196.087 58.0664H204.429"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M197.959 86.5455L196.759 85.8535"
      stroke="#6B7073"
      strokeWidth={0.38}
      strokeLinejoin="round"
    />
    <path
      d="M196.76 58.1094V85.8526L144.289 116.148"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M182.291 131.824L183.745 132.668L185.339 131.748V130.065L188.881 128.021M187.421 128.859L188.881 129.697L190.475 128.777V127.094L194.017 125.05M192.557 125.894L194.017 126.732L195.611 125.812V124.13L199.153 122.085M161.747 143.683L163.208 144.521L164.801 143.601V141.918L168.344 139.874M166.883 140.718L168.337 141.556L169.931 140.636V138.953L173.473 136.909M172.019 137.754L173.48 138.598L175.073 137.677V135.995L178.616 133.951M177.155 134.789L178.616 135.633L180.209 134.713V133.03L183.752 130.986M197.636 122.949L199.096 123.793C208.587 118.117 216.136 111.286 216.136 95.5546V33.8846C216.136 29.0343 214.536 25.8156 211.882 24.2284L204.829 20.2034C201.445 18.1719 196.341 18.8004 190.665 22.0763L143.775 49.1529C133.642 55 125.357 60.6184 125.357 78.204V139.874C125.357 145.416 126.9 148.718 129.465 150.203L136.499 154.222C139.616 156.044 144.168 155.263 149.387 152.514V150.832L152.929 148.787"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M157.938 145.448L161.436 144.679C162.033 144.603 162.693 144.375 163.391 143.975L189.814 128.719C192.436 127.208 194.582 125.843 194.582 121.202V102.753C194.582 102.557 194.569 102.379 194.55 102.201L193.909 98.1063C193.083 94.9066 189.865 94.0623 186.989 95.7192L155.462 113.921C152.592 115.578 154.592 117.209 154.592 120.085"
      fill="white"
    />
    <path
      d="M147.303 136.567C146.884 136.338 146.624 135.83 146.624 135.094C146.624 133.672 147.602 131.958 148.808 131.259C149.373 130.929 149.887 130.891 150.281 131.082M148.516 137.265C148.091 137.043 147.824 136.529 147.824 135.786C147.824 134.364 148.802 132.65 150.008 131.951C150.573 131.628 151.087 131.583 151.481 131.774"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinejoin="round"
    />
    <path
      d="M150.282 131.08L151.482 131.772C151.92 131.988 152.199 132.509 152.199 133.264C152.199 134.686 151.221 136.4 150.015 137.099C149.437 137.435 148.91 137.473 148.523 137.264L147.311 136.565"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M197.915 107.344C197.496 107.116 197.235 106.608 197.235 105.871C197.235 104.449 198.213 102.735 199.419 102.037C199.984 101.713 200.499 101.669 200.892 101.859L202.092 102.551M199.127 108.043C198.702 107.82 198.435 107.306 198.435 106.563C198.435 105.141 199.413 103.427 200.619 102.729C201.184 102.405 201.698 102.361 202.092 102.551M202.092 102.551C202.53 102.767 202.809 103.288 202.809 104.043C202.809 105.465 201.831 107.179 200.625 107.878C200.047 108.208 199.521 108.252 199.133 108.049L197.921 107.351"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M143.958 111.356C142.409 112.143 141.171 111.337 141.171 109.483V107.001C141.171 105.153 142.403 102.925 143.945 101.922"
      stroke="#6B7073"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M143.964 101.916V111.356"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinejoin="round"
    />
    <path
      d="M204.574 75.1238L202.46 75.1048C200.828 75.0858 199.495 73.5113 199.495 71.5877C199.495 69.6641 200.822 68.115 202.46 68.1341L204.574 68.1531M204.543 68.1659L205.216 67.7786C206.847 66.8327 208.18 67.6326 208.18 69.5562C208.18 71.4798 206.854 73.8098 205.216 74.7557L204.555 75.1366"
      stroke="#6B7073"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M199.616 72.4962C199.68 72.4708 199.75 72.4327 199.819 72.3947L201.927 71.1757C202.765 70.6932 203.444 69.4997 203.444 68.5093C203.444 68.3951 203.438 68.2871 203.419 68.1855"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M143.164 102.532V93.4216C143.164 89.4157 145.881 84.6035 149.227 82.6735C152.465 80.8007 155.112 82.3053 155.283 86.0255M204.872 68.1035C204.701 69.9319 203.444 72.0015 201.933 72.8776L200.143 73.9125"
      stroke="#6B7073"
      strokeWidth={0.38}
      strokeLinejoin="round"
    />
    <path
      d="M193.248 64.1156C193.419 60.1985 196.067 55.6275 199.305 53.761C202.657 51.8247 205.367 53.5071 205.367 57.5067V67.7025"
      stroke="#6B7073"
      strokeWidth={0.38}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M177.562 67.3535L179.961 68.7375C180.247 68.8835 180.431 69.2263 180.431 69.7152V73.0164C180.431 73.956 179.784 75.0861 178.99 75.5495L174.343 78.235C173.981 78.4445 173.651 78.4762 173.397 78.3619L170.883 76.9145"
      fill="white"
    />
    <path
      d="M177.562 67.3535L179.961 68.7375C180.247 68.8835 180.431 69.2263 180.431 69.7152V73.0164C180.431 73.956 179.784 75.0861 178.99 75.5495L174.343 78.235C173.981 78.4445 173.651 78.4762 173.397 78.3619L170.883 76.9145"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M177.231 70.8457V72.1599C177.231 72.5408 176.92 73.036 176.533 73.2582L173.708 74.8897"
      stroke="#6B7073"
      strokeWidth={0.38}
      strokeLinejoin="round"
    />
    <path
      d="M170.883 76.9146C170.648 76.7495 170.502 76.4257 170.502 75.9877V72.6864C170.502 71.7532 171.15 70.6168 171.943 70.1533L176.59 67.4679C176.965 67.252 177.301 67.2266 177.562 67.3473"
      fill="white"
    />
    <path
      d="M170.883 76.9146C170.648 76.7495 170.502 76.4257 170.502 75.9877V72.6864C170.502 71.7532 171.15 70.6168 171.943 70.1533L176.59 67.4679C176.965 67.252 177.301 67.2266 177.562 67.3473"
      stroke="#6B7073"
      strokeWidth={0.38}
      strokeLinejoin="round"
    />
    <path
      d="M176.406 71.3022C176.628 71.2832 176.787 71.4546 176.787 71.7593C176.787 72.1656 176.508 72.6545 176.159 72.8576C175.816 73.0544 175.53 72.8894 175.53 72.4831C175.53 72.2228 175.644 71.9244 175.822 71.6958M174.571 72.3942C174.768 72.4069 174.895 72.5719 174.895 72.8513C174.895 73.2576 174.616 73.7464 174.267 73.9496C174.051 74.0765 173.86 74.0575 173.746 73.9242"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M173.397 78.3627C173.092 78.223 172.901 77.8802 172.901 77.366V74.0647C172.901 73.1251 173.549 71.9951 174.342 71.5316L178.99 68.8462C179.364 68.6303 179.707 68.5986 179.967 68.7319M178.933 74.6424L174.393 77.2644C174.012 77.4866 173.695 77.3533 173.695 76.9723V73.5505C173.695 73.1696 174.006 72.6744 174.393 72.4522L178.933 69.8302C179.313 69.608 179.631 69.7413 179.631 70.1222V73.5441C179.631 73.925 179.32 74.4202 178.933 74.6424Z"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinejoin="round"
    />
    <path
      d="M197.915 47.3436C197.496 47.115 197.235 46.6071 197.235 45.8707C197.235 44.4486 198.213 42.7345 199.419 42.0362C199.984 41.706 200.499 41.668 200.886 41.8521"
      fill="white"
    />
    <path
      d="M197.915 47.3436C197.496 47.115 197.235 46.6071 197.235 45.8707C197.235 44.4486 198.213 42.7345 199.419 42.0362C199.984 41.706 200.499 41.668 200.886 41.8521"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M200.892 41.8574L202.092 42.5494C202.53 42.7653 202.809 43.2859 202.809 44.0413C202.809 45.4634 201.832 47.1775 200.625 47.8759C200.048 48.206 199.521 48.2504 199.133 48.0473L197.921 47.3489"
      fill="white"
    />
    <path
      d="M200.892 41.8574L202.092 42.5494C202.53 42.7653 202.809 43.2859 202.809 44.0413C202.809 45.4634 201.832 47.1775 200.625 47.8759C200.048 48.206 199.521 48.2504 199.133 48.0473L197.921 47.3489"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M199.128 48.042C198.702 47.8198 198.436 47.3056 198.436 46.5628C198.436 45.1407 199.413 43.4266 200.619 42.7283C201.184 42.4045 201.699 42.3601 202.092 42.5505"
      fill="white"
    />
    <path
      d="M199.128 48.042C198.702 47.8198 198.436 47.3056 198.436 46.5628C198.436 45.1407 199.413 43.4266 200.619 42.7283C201.184 42.4045 201.699 42.3601 202.092 42.5505"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinejoin="round"
    />
    <path
      d="M157.938 145.441C155.983 145.815 154.586 144.717 154.586 142.508V120.078"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M194.536 102.195C194.251 100.004 192.232 99.3313 189.807 100.734L163.384 115.99C160.762 117.501 158.616 119.044 158.616 123.507V141.956C158.616 143.886 159.772 144.882 161.429 144.679"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M193.934 98.3476L193.896 98.1063C193.071 94.9066 189.852 94.0623 186.976 95.7192L155.449 113.921C152.58 115.578 154.579 117.209 154.579 120.085"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M157.938 145.442L161.436 144.674C162.032 144.598 162.693 144.369 163.391 143.969L189.814 128.713C192.436 127.202 194.581 125.837 194.581 121.197V102.748C194.581 102.551 194.569 102.373 194.55 102.195L193.947 98.3418"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M172.845 136.389C171.664 136.89 170.756 136.224 170.756 134.789V131.113C170.756 128.555 171.835 127.659 173.162 126.891L180.037 122.923C181.269 122.212 182.291 122.72 182.425 124.047"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M174.895 135.442C174.323 135.772 173.854 135.575 173.854 135.004V131.144C173.854 130.573 174.323 129.83 174.895 129.5L181.611 125.621C182.183 125.291 182.659 125.488 182.659 126.065"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M170.089 60.2053C171.206 59.672 172.139 59.2213 173.974 59.1324M182.627 41.7246C182.627 43.0705 183.065 45.2354 183.643 46.2067M182.424 124.04L182.653 126.059V129.913C182.653 130.49 182.183 131.227 181.612 131.557L174.895 135.436L172.838 136.382"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M188.087 24.6288C188.418 24.8192 188.945 24.8256 189.268 24.6351C189.592 24.451 189.586 24.1399 189.256 23.9495C188.926 23.759 188.399 23.759 188.075 23.9495C187.751 24.1336 187.757 24.4447 188.087 24.6351V24.6288ZM185.904 25.2002C186.227 25.016 186.754 25.016 187.084 25.2065C187.415 25.397 187.421 25.7017 187.097 25.8858C186.773 26.0763 186.246 26.0699 185.916 25.8858C185.586 25.6953 185.58 25.3906 185.904 25.2002ZM183.726 26.4508C184.05 26.2667 184.583 26.2667 184.907 26.4572C185.237 26.6476 185.243 26.9524 184.92 27.1365C184.596 27.3206 184.069 27.3206 183.739 27.1365C183.409 26.946 183.402 26.6413 183.726 26.4508ZM181.555 27.7078C181.879 27.5237 182.406 27.5237 182.736 27.7142C183.066 27.9046 183.072 28.2094 182.748 28.3998C182.425 28.5839 181.898 28.5839 181.568 28.3998C181.237 28.2094 181.231 27.9046 181.555 27.7142V27.7078ZM179.384 28.9649C179.707 28.7807 180.234 28.7807 180.564 28.9649C180.895 29.1553 180.901 29.46 180.577 29.6505C180.253 29.8346 179.726 29.8346 179.396 29.6505C179.066 29.46 179.06 29.1553 179.384 28.9649ZM177.212 30.2155C177.536 30.0314 178.063 30.0314 178.393 30.2155C178.723 30.406 178.73 30.7107 178.406 30.9012C178.082 31.0853 177.555 31.0853 177.225 30.8948C176.895 30.7044 176.889 30.3996 177.212 30.2155ZM175.035 31.4725C175.359 31.2821 175.886 31.2884 176.216 31.4725C176.546 31.663 176.552 31.9677 176.228 32.1582C175.905 32.3423 175.371 32.3423 175.048 32.1518C174.717 31.9614 174.711 31.6566 175.035 31.4725ZM172.864 32.7232C173.187 32.5391 173.714 32.5391 174.044 32.7296C174.375 32.92 174.381 33.2248 174.057 33.4152C173.733 33.5993 173.206 33.5993 172.876 33.4089C172.546 33.2184 172.54 32.9137 172.864 32.7232ZM170.692 33.9802C171.016 33.7961 171.543 33.7961 171.873 33.9866C172.203 34.177 172.21 34.4818 171.886 34.6722C171.562 34.8563 171.035 34.8563 170.705 34.6722C170.375 34.4818 170.369 34.177 170.692 33.9866V33.9802ZM168.521 35.2309C168.845 35.0468 169.372 35.0468 169.702 35.2372C170.032 35.4277 170.038 35.7324 169.715 35.9165C169.391 36.1006 168.864 36.1006 168.534 35.9165C168.204 35.7261 168.197 35.4214 168.521 35.2309ZM166.344 36.4879C166.667 36.3038 167.194 36.3038 167.524 36.4943C167.855 36.6847 167.861 36.9895 167.537 37.1736C167.213 37.3577 166.686 37.3577 166.356 37.1736C166.026 36.9831 166.02 36.6784 166.344 36.4879ZM164.172 37.7449C164.496 37.5608 165.023 37.5608 165.353 37.7449C165.683 37.9354 165.69 38.2401 165.366 38.4306C165.042 38.6147 164.515 38.6147 164.185 38.4306C163.855 38.2401 163.849 37.9354 164.172 37.7449ZM162.001 38.9956C162.325 38.8115 162.852 38.8115 163.182 38.9956C163.512 39.1861 163.519 39.4908 163.195 39.6812C162.871 39.8654 162.344 39.8654 162.014 39.6749C161.684 39.4844 161.677 39.1797 162.001 38.9893V38.9956ZM159.824 40.2526C160.147 40.0622 160.674 40.0685 161.004 40.2526C161.335 40.4431 161.341 40.7478 161.017 40.9383C160.693 41.1224 160.166 41.1224 159.836 40.9319C159.506 40.7415 159.5 40.4367 159.824 40.2526ZM157.652 41.5096C157.976 41.3255 158.503 41.3255 158.833 41.516C159.163 41.7064 159.17 42.0112 158.846 42.2016C158.522 42.3857 157.995 42.3857 157.665 42.1953C157.335 42.0048 157.329 41.7001 157.652 41.5096ZM155.481 42.7603C155.805 42.5762 156.332 42.5762 156.662 42.7667C156.992 42.9571 156.999 43.2618 156.675 43.4523C156.351 43.6364 155.818 43.6364 155.494 43.4523C155.164 43.2618 155.157 42.9571 155.481 42.7667V42.7603ZM153.31 44.0173C153.634 43.8332 154.161 43.8332 154.491 44.0237C154.821 44.2141 154.827 44.5189 154.504 44.7093C154.18 44.8934 153.653 44.8934 153.323 44.7093C152.993 44.5189 152.986 44.2141 153.31 44.0237V44.0173ZM151.132 45.268C151.456 45.0839 151.989 45.0839 152.313 45.268C152.643 45.4585 152.65 45.7632 152.326 45.9536C152.002 46.1377 151.475 46.1377 151.145 45.9536C150.815 45.7632 150.809 45.4585 151.132 45.268ZM148.961 46.525C149.285 46.3409 149.812 46.3409 150.142 46.525C150.472 46.7155 150.479 47.0202 150.155 47.2107C149.831 47.4011 149.298 47.3948 148.974 47.2043C148.644 47.0139 148.637 46.7091 148.961 46.5187V46.525ZM146.79 47.782C147.114 47.5979 147.641 47.5979 147.971 47.782C148.301 47.9725 148.307 48.2772 147.984 48.4677C147.66 48.6518 147.133 48.6518 146.803 48.4613C146.473 48.2709 146.466 47.9661 146.79 47.7757V47.782ZM145.8 49.039C146.13 49.2295 146.136 49.5342 145.812 49.7247C145.489 49.9088 144.962 49.9088 144.631 49.7183C144.301 49.5279 144.295 49.2232 144.619 49.0327C144.943 48.8422 145.476 48.8486 145.8 49.0327V49.039Z"
      stroke="#6B7073"
      strokeWidth={0.38}
      strokeLinejoin="round"
    />
    <path
      d="M149.717 108.868V112.74L152.536 113.966L159.697 109.826V105.287"
      fill="white"
    />
    <path
      d="M149.717 108.868V112.74L152.536 113.966L159.697 109.826V105.287"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M151.628 109.229L148.942 111.266V115.082L149.85 115.602L152.529 113.565V109.749L151.628 109.229Z"
      fill="white"
    />
    <path
      d="M151.628 109.229L148.942 111.266V115.082L149.85 115.602L152.529 113.565V109.749L151.628 109.229Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M149.85 115.61V111.788L152.529 109.75"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeMiterlimit={10}
    />
    <path
      d="M152.593 109.388L159.697 105.287"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M149.628 104.36V108.239L152.447 109.458L159.608 105.319V100.779"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M151.538 104.721L148.853 106.759V110.58L149.76 111.101L152.439 109.057V105.241L151.538 104.721Z"
      fill="white"
    />
    <path
      d="M151.538 104.721L148.853 106.759V110.58L149.76 111.101L152.439 109.057V105.241L151.538 104.721Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M149.762 111.102V107.286L152.441 105.242"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeMiterlimit={10}
    />
    <path
      d="M152.504 104.88L159.608 100.779"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M149.628 99.8208V103.693L152.447 104.912L159.608 100.779V96.2402"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M151.538 100.184L148.853 102.221V106.037L149.76 106.558L152.439 104.52V100.704L151.538 100.184Z"
      fill="white"
    />
    <path
      d="M151.538 100.184L148.853 102.221V106.037L149.76 106.558L152.439 104.52V100.704L151.538 100.184Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M149.762 106.563V102.741L152.441 100.703"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeMiterlimit={10}
    />
    <path
      d="M152.504 100.341L159.608 96.2402"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M149.628 95.2759V99.1549L152.447 100.374L159.608 96.2345V91.6953"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M151.538 95.6367L148.853 97.6746V101.496L149.76 102.017L152.439 99.9728V96.1573L151.538 95.6367Z"
      fill="white"
    />
    <path
      d="M151.538 95.6367L148.853 97.6746V101.496L149.76 102.017L152.439 99.9728V96.1573L151.538 95.6367Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M149.762 102.018V98.2024L152.441 96.1582"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeMiterlimit={10}
    />
    <path
      d="M152.504 95.7965L159.608 91.6953"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M149.628 90.7349V94.6075L152.447 95.8328L159.608 91.6935V87.1543"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M151.538 91.0977L148.853 93.1355V96.951L149.76 97.4716L152.439 95.4337V91.6182L151.538 91.0977Z"
      fill="white"
    />
    <path
      d="M151.538 91.0977L148.853 93.1355V96.951L149.76 97.4716L152.439 95.4337V91.6182L151.538 91.0977Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M149.762 97.4789V93.657L152.441 91.6191"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeMiterlimit={10}
    />
    <path
      d="M152.504 91.2555L159.608 87.1543"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M149.628 87.016V90.0697L152.447 91.2886L159.608 87.1557V84.0449"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M151.011 86.9512L148.853 88.5955V92.4109L149.76 92.9315L152.439 90.8936V87.0718L152.325 87.0083"
      fill="white"
    />
    <path
      d="M151.011 86.9512L148.853 88.5955V92.4109L149.76 92.9315L152.439 90.8936V87.0718L152.325 87.0083"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M149.762 92.932V89.1165L152.441 87.0723"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeMiterlimit={10}
    />
    <path
      d="M183.288 70.3119V70.6293L186.107 71.8546L193.274 67.7153V64.5156"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M186.106 68.7324V71.8559"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeMiterlimit={10}
    />
    <path
      d="M194.119 62.3522L196.125 61.5586L196.817 61.9586V65.7741L193.274 67.3168"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M196.816 61.957L194.169 63.0363"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M181.543 71.4492C181.606 71.7032 181.638 71.9825 181.638 72.2936V90.3172C181.638 94.5136 179.752 95.5992 177.441 96.9324L165.316 103.935C163.011 105.268 161.119 104.468 161.119 102.164V84.14C161.119 83.7972 161.164 83.448 161.24 83.0862"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M162.801 82.3181C162.655 82.7688 162.572 83.2259 162.572 83.6576V100.977C162.572 102.545 163.658 103.192 164.991 102.424L177.777 95.0406C179.11 94.2724 180.196 92.3679 180.196 90.7998V74.2871"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinejoin="round"
    />
    <path
      d="M190.455 89.2051L193.274 90.424"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M192.938 85.6496L196.124 84.2656L196.816 84.6656V88.4811L193.274 90.0301"
      fill="white"
    />
    <path
      d="M192.938 85.6496L196.124 84.2656L196.816 84.6656V88.4811L193.274 90.0301"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M183.288 88.7988V93.3443L186.107 94.5633L193.274 90.424V85.8848"
      fill="white"
    />
    <path
      d="M183.288 88.7988V93.3443L186.107 94.5633L193.274 90.424V85.8848"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M186.106 94.5646V90.0254"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M196.817 84.666L193.274 86.2087"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinejoin="round"
    />
    <path
      d="M192.938 81.111L196.124 79.7207L196.816 80.127V83.9425L193.274 85.4852"
      fill="white"
    />
    <path
      d="M192.938 81.111L196.124 79.7207L196.816 80.127V83.9425L193.274 85.4852"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M183.288 84.2597V88.7989L186.107 90.0178L193.274 85.8849V81.3457"
      fill="white"
    />
    <path
      d="M183.288 84.2597V88.7989L186.107 90.0178L193.274 85.8849V81.3457"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M186.106 90.0241V85.4785"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M196.817 80.127L193.274 81.6697"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinejoin="round"
    />
    <path
      d="M190.455 80.1211L193.274 81.34"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M192.938 76.5656L196.124 75.1816L196.816 75.5816V79.4034L193.274 80.9461"
      fill="white"
    />
    <path
      d="M192.938 76.5656L196.124 75.1816L196.816 75.5816V79.4034L193.274 80.9461"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M183.288 79.7211V84.2604L186.107 85.4793L193.274 81.3464V76.8008"
      fill="white"
    />
    <path
      d="M183.288 79.7211V84.2604L186.107 85.4793L193.274 81.3464V76.8008"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M186.106 85.4787V80.9395"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M196.817 75.582L193.274 77.1247"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinejoin="round"
    />
    <path
      d="M193.281 71.8742L196.125 70.6426L196.817 71.0425V74.858L193.274 76.4007"
      fill="white"
    />
    <path
      d="M193.281 71.8742L196.125 70.6426L196.817 71.0425V74.858L193.274 76.4007"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M183.288 75.1757V79.7149L186.107 80.9402L193.274 76.801V72.2617"
      fill="white"
    />
    <path
      d="M183.288 75.1757V79.7149L186.107 80.9402L193.274 76.801V72.2617"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M186.106 80.9401V76.3945"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M196.817 71.043L193.274 72.5857"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinejoin="round"
    />
    <path
      d="M193.242 67.3483L196.124 66.0977L196.816 66.504V70.3195L193.388 71.8114"
      fill="white"
    />
    <path
      d="M193.242 67.3483L196.124 66.0977L196.816 66.504V70.3195L193.388 71.8114"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M183.288 70.6371V75.1764L186.107 76.3953L193.274 72.2624V67.7168"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M186.106 76.3947V71.8555"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M196.817 66.498L193.274 68.0407"
      stroke="#6B7073"
      strokeWidth={0.35}
      strokeLinejoin="round"
    />
    <path
      d="M146.01 86.8828H154.491"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M187.224 52.5184C188.805 52.5184 190.081 51.236 190.081 49.6615C190.081 48.0871 188.805 46.8047 187.224 46.8047C185.643 46.8047 184.367 48.0871 184.367 49.6615C184.367 51.236 185.643 52.5184 187.224 52.5184Z"
      fill="white"
    />
    <rect
      x={221.001}
      y={19.0039}
      width={17.2584}
      height={17.2584}
      rx={8.62918}
      fill="#01B5DE"
    />
    <path
      d="M227.164 30.6328V29.8128L230.054 27.2128C230.348 26.9461 230.568 26.6961 230.714 26.4628C230.861 26.2228 230.934 25.9395 230.934 25.6128C230.934 25.2395 230.811 24.9461 230.564 24.7328C230.324 24.5195 230.018 24.4128 229.644 24.4128C229.211 24.4128 228.858 24.5361 228.584 24.7828C228.318 25.0295 228.174 25.3695 228.154 25.8028H227.234C227.254 25.3695 227.371 24.9795 227.584 24.6328C227.798 24.2861 228.081 24.0161 228.434 23.8228C228.788 23.6295 229.188 23.5328 229.634 23.5328C230.054 23.5328 230.431 23.6161 230.764 23.7828C231.104 23.9495 231.371 24.1861 231.564 24.4928C231.758 24.7995 231.854 25.1561 231.854 25.5628C231.854 25.9961 231.754 26.3861 231.554 26.7328C231.361 27.0728 231.071 27.4128 230.684 27.7528L228.414 29.7528H231.994V30.6328H227.164Z"
      fill="white"
    />
    <path
      d="M268.1 106.646L244.164 92.6014L241.112 92.6999L242.515 95.4123L266.451 109.457M264.876 111.51C265.396 111.816 266.11 111.779 266.911 111.304C267.712 110.83 268.438 110.024 268.967 109.094C269.495 108.165 269.833 107.115 269.847 106.17C269.862 105.225 269.545 104.559 269.028 104.247L267.842 103.551C267.321 103.245 266.608 103.282 265.806 103.757C265.005 104.231 264.279 105.037 263.747 105.973C263.218 106.902 262.881 107.952 262.866 108.897C262.858 109.845 263.169 110.509 263.686 110.82L264.872 111.516L264.876 111.51Z"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M268.108 106.65L244.159 92.5975L241.107 92.696L242.506 95.4146L266.455 109.467"
      fill="white"
    />
    <path
      d="M263.824 107.941C263.473 107.347 263.871 106.424 264.709 105.887C265.356 105.474 266.072 105.405 266.527 105.663"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M266.359 108.94C266.262 108.832 266.202 108.662 266.206 108.453C266.206 107.879 266.62 107.187 267.129 106.895C267.319 106.787 267.491 106.753 267.642 106.782M242.762 95.4817C242.428 94.9148 242.799 94.0528 243.596 93.5422C244.203 93.1557 244.882 93.0904 245.312 93.3345M244.076 96.2611C243.742 95.6942 244.117 94.8259 244.914 94.3153C245.52 93.9288 246.2 93.8635 246.64 94.105M245.39 97.0405C245.056 96.4736 245.428 95.5953 246.232 95.0884C246.842 94.6957 247.527 94.634 247.958 94.8781M246.707 97.8136C246.367 97.243 246.746 96.3684 247.553 95.8552C248.169 95.4662 248.848 95.4009 249.289 95.6424M248.028 98.5967C247.688 98.0261 248.07 97.1452 248.877 96.632C249.493 96.243 250.182 96.1751 250.619 96.4229M249.342 99.376C249.002 98.8054 249.381 97.9146 250.188 97.4014C250.808 97.0061 251.497 96.9382 251.94 97.1897M250.655 100.155C250.313 99.5749 250.695 98.694 251.506 98.1746C252.126 97.7792 252.821 97.715 253.268 97.9602M251.973 100.929C251.63 100.348 252.016 99.4609 252.827 98.9414C253.447 98.5461 254.146 98.4756 254.589 98.727M253.293 101.712C252.951 101.131 253.334 100.234 254.151 99.7182C254.774 99.3166 255.476 99.2561 255.923 99.5012M254.607 102.491C254.265 101.91 254.648 101.013 255.468 100.491C256.098 100.093 256.798 100.023 257.247 100.278M255.925 103.264C255.576 102.68 255.969 101.78 256.793 101.252C257.427 100.848 258.129 100.787 258.582 101.036M257.239 104.043C256.89 103.459 257.28 102.55 258.111 102.025C258.745 101.621 259.45 101.554 259.899 101.809M258.553 104.823C258.207 104.232 258.594 103.329 259.428 102.798C260.062 102.394 260.774 102.331 261.227 102.58M259.873 105.606C259.528 105.015 259.918 104.106 260.746 103.571C261.39 103.164 262.095 103.098 262.551 103.356M261.19 106.379C260.839 105.785 261.233 104.869 262.067 104.338C262.711 103.931 263.426 103.862 263.882 104.121M262.504 107.158C262.153 106.564 262.547 105.648 263.385 105.111C264.029 104.704 264.744 104.635 265.206 104.897"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M268.104 106.657L245.768 93.5509L244.168 92.6122L241.12 92.7044L242.526 95.4105L266.469 109.459"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M264.879 111.52C265.399 111.826 266.113 111.789 266.914 111.314C267.715 110.84 268.445 110.028 268.973 109.098C269.502 108.169 269.84 107.119 269.858 106.168C269.866 105.219 269.555 104.556 269.038 104.244L267.852 103.549C267.332 103.243 266.618 103.28 265.817 103.754C265.016 104.229 264.286 105.041 263.758 105.97C263.229 106.9 262.891 107.95 262.883 108.898C262.875 109.847 263.182 110.516 263.703 110.822L264.889 111.518L264.879 111.52Z"
      fill="white"
    />
    <path
      d="M264.966 108.957C265.798 108.661 266.498 108.329 267.088 108C267.089 107.048 267 106.195 266.895 105.568C266.926 105.544 266.963 105.524 266.991 105.506C267.171 105.401 267.348 105.328 267.511 105.28C267.609 105.861 267.715 106.673 267.737 107.597C268.269 107.251 268.666 106.919 268.958 106.652C268.955 106.658 268.96 106.678 268.956 106.685C268.952 106.994 268.897 107.316 268.801 107.639C268.505 107.871 268.149 108.117 267.731 108.37C267.719 108.793 267.68 109.234 267.614 109.676C267.401 109.896 267.163 110.086 266.925 110.233C266.897 110.251 266.874 110.262 266.84 110.276C266.946 109.765 267.02 109.251 267.054 108.748C266.473 109.048 265.801 109.346 265.016 109.619C264.972 109.45 264.949 109.259 264.953 109.051C264.955 109.018 264.961 108.979 264.957 108.943"
      fill="#6B7073"
    />
    <path
      d="M269.033 104.24C268.512 103.935 267.799 103.972 267.004 104.45C266.202 104.924 265.473 105.736 264.944 106.666C264.416 107.595 264.078 108.646 264.063 109.59C264.049 110.535 264.36 111.198 264.877 111.51"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M266.904 111.316C266.103 111.791 265.39 111.828 264.869 111.522L263.683 110.826C263.166 110.514 262.855 109.851 262.863 108.903C262.878 107.958 263.216 106.908 263.744 105.979C264.273 105.049 265.002 104.237 265.803 103.763C266.605 103.288 267.318 103.251 267.839 103.557L269.025 104.253C269.542 104.564 269.853 105.228 269.845 106.176C269.83 107.12 269.492 108.171 268.964 109.1C268.435 110.03 267.706 110.842 266.904 111.316Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M242.203 163.455L218.267 149.41L215.215 149.509L216.617 152.221L240.554 166.266M238.978 168.319C239.499 168.624 240.212 168.587 241.013 168.113C241.815 167.638 242.54 166.833 243.069 165.903C243.598 164.973 243.936 163.923 243.95 162.979C243.964 162.034 243.647 161.367 243.13 161.055L241.944 160.359C241.424 160.054 240.71 160.091 239.909 160.565C239.108 161.04 238.382 161.845 237.85 162.781C237.321 163.711 236.983 164.761 236.969 165.706C236.961 166.654 237.271 167.317 237.789 167.629L238.974 168.325L238.978 168.319Z"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M242.211 163.458L218.262 149.406L215.21 149.505L216.609 152.223L240.558 166.275"
      fill="white"
    />
    <path
      d="M237.927 164.749C237.576 164.155 237.973 163.233 238.811 162.696C239.459 162.283 240.174 162.213 240.629 162.472"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M240.462 165.748C240.365 165.641 240.305 165.47 240.309 165.262C240.308 164.688 240.723 163.995 241.232 163.703C241.421 163.595 241.593 163.561 241.745 163.591M216.865 152.29C216.531 151.723 216.902 150.861 217.699 150.351C218.305 149.964 218.985 149.899 219.415 150.143M218.178 153.07C217.845 152.503 218.219 151.634 219.017 151.124C219.623 150.737 220.302 150.672 220.742 150.914M219.492 153.849C219.159 153.282 219.531 152.404 220.334 151.897C220.944 151.504 221.63 151.443 222.06 151.687M220.81 154.622C220.47 154.052 220.848 153.177 221.655 152.664C222.272 152.275 222.951 152.209 223.391 152.451M222.13 155.405C221.79 154.835 222.172 153.954 222.979 153.441C223.596 153.052 224.285 152.984 224.721 153.231M223.444 156.185C223.104 155.614 223.483 154.723 224.291 154.21C224.911 153.815 225.6 153.747 226.043 153.998M224.758 156.964C224.415 156.383 224.797 155.503 225.608 154.983C226.228 154.588 226.924 154.524 227.37 154.769M226.076 157.737C225.733 157.157 226.119 156.269 226.929 155.75C227.549 155.355 228.249 155.284 228.692 155.536M227.396 158.52C227.053 157.94 227.436 157.043 228.253 156.527C228.877 156.125 229.579 156.065 230.025 156.31M228.71 159.3C228.367 158.719 228.75 157.822 229.571 157.3C230.201 156.902 230.9 156.831 231.349 157.087M230.027 160.073C229.678 159.488 230.071 158.589 230.896 158.06C231.529 157.656 232.231 157.596 232.684 157.845M231.341 160.852C230.992 160.268 231.383 159.358 232.213 158.834C232.847 158.429 233.553 158.363 234.002 158.618M232.655 161.631C232.31 161.041 232.697 160.138 233.531 159.607C234.165 159.202 234.876 159.139 235.329 159.388M233.975 162.414C233.63 161.824 234.02 160.914 234.849 160.38C235.492 159.973 236.198 159.906 236.653 160.165M235.293 163.188C234.941 162.593 235.335 161.678 236.17 161.147C236.813 160.74 237.529 160.67 237.984 160.929M236.607 163.967C236.255 163.373 236.649 162.457 237.488 161.92C238.131 161.513 238.847 161.444 239.308 161.706"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M242.207 163.466L219.871 150.36L218.271 149.421L215.222 149.513L216.629 152.219L240.571 166.268"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M238.981 168.329C239.502 168.634 240.215 168.597 241.017 168.123C241.818 167.648 242.547 166.837 243.076 165.907C243.605 164.977 243.942 163.927 243.96 162.976C243.969 162.028 243.658 161.365 243.141 161.053L241.955 160.357C241.434 160.052 240.721 160.089 239.919 160.563C239.118 161.037 238.389 161.849 237.86 162.779C237.331 163.709 236.994 164.759 236.985 165.707C236.977 166.655 237.285 167.325 237.805 167.63L238.991 168.326L238.981 168.329Z"
      fill="white"
    />
    <path
      d="M239.068 165.766C239.9 165.469 240.601 165.138 241.19 164.809C241.192 163.857 241.103 163.003 240.998 162.377C241.029 162.353 241.066 162.332 241.093 162.315C241.273 162.209 241.451 162.137 241.614 162.089C241.712 162.669 241.817 163.482 241.84 164.406C242.372 164.06 242.769 163.728 243.061 163.461C243.057 163.467 243.062 163.487 243.059 163.493C243.054 163.803 243 164.125 242.903 164.448C242.607 164.679 242.252 164.926 241.834 165.178C241.822 165.601 241.782 166.042 241.717 166.484C241.503 166.705 241.265 166.894 241.027 167.041C241 167.059 240.976 167.071 240.943 167.085C241.049 166.573 241.122 166.06 241.156 165.557C240.575 165.857 239.903 166.154 239.119 166.428C239.075 166.258 239.051 166.068 239.056 165.859C239.058 165.827 239.064 165.788 239.06 165.752"
      fill="#6B7073"
    />
    <path
      d="M243.135 161.049C242.615 160.743 241.901 160.78 241.106 161.258C240.305 161.733 239.575 162.545 239.047 163.474C238.518 164.404 238.18 165.454 238.166 166.399C238.151 167.343 238.462 168.007 238.979 168.318"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M241.007 168.125C240.205 168.599 239.492 168.636 238.971 168.331L237.786 167.635C237.269 167.323 236.958 166.66 236.966 165.712C236.98 164.767 237.318 163.717 237.847 162.787C238.375 161.858 239.105 161.046 239.906 160.571C240.707 160.097 241.421 160.06 241.941 160.365L243.127 161.061C243.644 161.373 243.955 162.036 243.947 162.984C243.933 163.929 243.595 164.979 243.066 165.909C242.538 166.838 241.808 167.65 241.007 168.125Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M116.712 15.439C115.559 15.4627 114.221 15.4871 111.316 14.0695C111.178 13.9885 111.004 13.954 110.824 13.9745L110.07 13.9794C110.047 13.5442 109.227 12.8436 108.969 12.6926L108.48 12.4055C108.342 12.3245 108.175 12.2937 107.991 12.3042L106.51 11.9245C106.498 11.4704 106.334 11.1464 106.071 10.9918L105.581 10.7046C105.443 10.6236 105.276 10.5928 105.093 10.6034L103.612 10.2236C103.6 9.7696 103.436 9.44558 103.172 9.29096L102.683 9.0038C102.545 8.92281 102.371 8.88832 102.19 8.90881L100.784 9.01988C100.675 9.03217 100.559 9.07325 100.433 9.14309C100.169 9.29166 99.9295 9.55601 99.7528 9.85717C99.5761 10.1583 99.4658 10.49 99.4614 10.7995C99.4615 10.943 99.4827 11.0651 99.5248 11.1657L100.114 12.4475C100.19 12.6189 100.299 12.7501 100.443 12.8348L100.933 13.1219C101.196 13.2765 101.559 13.2618 101.961 13.0507L103.015 14.1583C103.092 14.3297 103.204 14.4546 103.342 14.5356L103.831 14.8228C104.095 14.9774 104.458 14.9626 104.86 14.7515L105.914 15.8591C105.99 16.0306 106.103 16.1554 106.241 16.2364L106.73 16.5236C106.987 16.6745 107.995 17.0552 108.39 16.8567L108.756 17.5268C108.833 17.6983 108.945 17.8232 109.083 17.9041C111.734 19.7546 112.369 20.9287 112.91 21.9464C113.172 22.4205 114.258 21.9782 113.651 21.0571C113.129 20.1939 112.396 19.1143 110.35 17.6859C110.357 17.6733 110.377 17.6681 110.39 17.6593L111.099 18.0753C112.624 18.9699 113.88 20.7105 113.88 20.7105L121.459 25.1577L125.594 28.562L125.857 28.7166L126.295 27.97C126.557 28.056 126.883 28.0029 127.239 27.7986C127.67 27.5535 128.064 27.1267 128.351 26.6373C128.638 26.1479 128.818 25.5959 128.822 25.1006C128.827 24.6901 128.708 24.3756 128.512 24.1929L128.95 23.4462L128.686 23.2916L123.698 21.343L116.118 16.8958C116.118 16.8958 113.986 16.6484 112.462 15.7538L111.762 15.2928C114.001 16.3788 115.301 16.4921 116.309 16.5271C117.416 16.6111 117.268 15.4535 116.724 15.4463L116.712 15.439Z"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M101.654 10.6264L101.665 10.6075C101.665 10.6075 101.658 10.6201 101.654 10.6264L114.811 18.3464C114.949 18.4274 115.002 18.6103 114.921 18.7483C114.84 18.8863 114.661 18.933 114.517 18.8484L101.359 11.1283C101.359 11.1283 101.356 11.1346 101.352 11.1408L101.359 11.1283L100.28 10.4951C100.142 10.4141 100.096 10.2349 100.177 10.0969C100.258 9.95882 100.437 9.91217 100.575 9.99316L101.648 10.6227L101.654 10.6264ZM116.719 15.4257C115.563 15.4558 114.228 15.4738 111.319 14.0625C111.181 13.9815 111.008 13.947 110.827 13.9675L110.073 13.9724C110.054 13.531 109.23 12.8366 108.973 12.6856L108.483 12.3985C108.345 12.3175 108.182 12.2804 107.995 12.2972L106.507 11.9138C106.499 11.4535 106.335 11.1295 106.072 10.9749L105.576 10.684C105.438 10.603 105.274 10.566 105.087 10.5828L103.6 10.1993C103.592 9.73902 103.427 9.41499 103.158 9.25668L102.668 8.96953C102.53 8.88854 102.36 8.84781 102.17 8.87088L100.763 8.98196C100.655 8.99425 100.538 9.03534 100.413 9.10518C100.148 9.25375 99.9089 9.5181 99.7322 9.81926C99.5555 10.1204 99.4415 10.4584 99.4407 10.7616C99.4409 10.905 99.4621 11.0271 99.5042 11.1277L100.093 12.4095C100.17 12.581 100.278 12.7122 100.423 12.7968L100.912 13.084C101.175 13.2386 101.538 13.2238 101.951 13.0102L103.011 14.1214C103.087 14.2928 103.199 14.4178 103.338 14.4988L103.833 14.7896C104.097 14.9442 104.46 14.9294 104.865 14.7121L105.926 15.8234C106.002 15.9948 106.114 16.1197 106.252 16.2007L106.742 16.4878C106.999 16.6388 108.011 17.0131 108.402 16.8209L108.768 17.4911C108.844 17.6625 108.957 17.7874 109.095 17.8684C111.745 19.7189 112.381 20.8929 112.918 21.917C113.18 22.391 114.266 21.9487 113.66 21.0276C113.137 20.1644 112.408 19.0786 110.361 17.6501C110.369 17.6376 110.389 17.6324 110.402 17.6235L111.111 18.0395C112.636 18.9341 113.888 20.681 113.888 20.681L121.474 25.1319L125.614 28.5398L125.884 28.6981L126.322 27.9516C126.584 28.0376 126.91 27.9844 127.27 27.7738C127.704 27.5225 128.098 27.0957 128.385 26.6063C128.672 26.117 128.853 25.565 128.86 25.0634C128.869 24.6466 128.746 24.3383 128.55 24.1556L128.988 23.409L128.718 23.2507L123.723 21.2984L116.138 16.8475C116.138 16.8475 113.995 16.6027 112.477 15.7118L111.778 15.2508C114.023 16.3405 115.32 16.4438 116.335 16.4825C117.441 16.5665 117.297 15.4026 116.75 15.4017"
      fill="white"
    />
    <path
      d="M100.283 10.5053C100.145 10.4243 100.098 10.245 100.179 10.107C100.26 9.96897 100.439 9.92229 100.578 10.0033L101.65 10.6328L101.352 11.141L100.279 10.5115L100.283 10.5053Z"
      fill="white"
    />
    <path
      d="M126.022 27.8164L121.43 25.1216"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M116.646 22.3145L116.208 23.0611"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M100.905 13.096C100.629 12.934 100.464 12.5838 100.467 12.0884C100.467 12.0036 100.472 11.9224 100.484 11.845M101.89 9.49065C101.945 9.45518 102 9.41968 102.05 9.39049C102.481 9.14548 102.867 9.11927 103.144 9.28125"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M101.665 10.6061C101.626 10.7013 101.577 10.7991 101.525 10.887C101.474 10.9748 101.419 11.0689 101.348 11.1457"
      fill="#6B7073"
    />
    <path
      d="M127.284 24.7614C127.579 24.5888 127.847 24.5774 128.035 24.6878C128.223 24.7983 128.344 25.0379 128.338 25.3798C128.331 25.7218 128.211 26.0985 128.012 26.4373C127.814 26.7761 127.543 27.0644 127.248 27.237C126.953 27.4096 126.685 27.421 126.496 27.3105C126.308 27.2001 126.187 26.9604 126.194 26.6185C126.201 26.2766 126.32 25.8999 126.519 25.5611C126.718 25.2223 126.982 24.9302 127.284 24.7614ZM127.289 24.1911C127.72 23.9461 128.106 23.9199 128.382 24.0819C128.658 24.2438 128.824 24.5941 128.82 25.0894C128.816 25.5848 128.636 26.1367 128.349 26.6261C128.061 27.1155 127.668 27.5423 127.237 27.7873C126.803 28.0386 126.42 28.0586 126.144 27.8966C125.868 27.7346 125.696 27.3807 125.706 26.889C125.716 26.3974 125.891 25.8417 126.178 25.3523C126.465 24.8629 126.859 24.4361 127.289 24.1911Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M102.994 14.1355C102.918 13.964 102.873 13.7524 102.877 13.5016C102.88 13.4105 102.886 13.313 102.903 13.2131M104.296 10.91C104.351 10.8746 104.409 10.8328 104.46 10.8036C104.677 10.678 104.884 10.6136 105.071 10.5968M100.083 12.4272C100.007 12.2558 99.9683 12.0478 99.9684 11.8033C99.9713 11.7122 99.9778 11.6148 99.988 11.5111M101.323 9.24984C101.399 9.19296 101.481 9.13978 101.559 9.09285C101.776 8.96721 101.976 8.89908 102.163 8.88228M110.355 17.6616C110.293 17.7096 110.229 17.7476 110.164 17.7857C109.734 18.0307 109.347 18.0569 109.065 17.8913M109.068 17.885C108.792 17.723 108.62 17.3691 108.624 16.8738C108.627 16.7827 108.636 16.6953 108.645 16.6078M110.016 14.3C110.078 14.252 110.146 14.2077 110.217 14.1733C110.651 13.922 111.034 13.902 111.317 14.0677M111.31 14.064C111.586 14.226 111.758 14.5799 111.754 15.0752C111.751 15.1239 111.754 15.1763 111.751 15.225"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M102.987 14.1327L101.677 12.5547M103.047 10.2207L105.069 10.5977"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M103.81 14.7995C103.534 14.6375 103.368 14.2873 103.372 13.792C103.374 13.7171 103.379 13.6359 103.385 13.5548M104.781 11.203C104.84 11.1613 104.898 11.1196 104.959 11.0878C105.389 10.8428 105.776 10.8165 106.052 10.9785"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M105.897 15.8399C105.821 15.6685 105.783 15.4605 105.787 15.2097C105.789 15.1186 105.792 15.0274 105.805 14.9337M107.151 12.6536C107.223 12.603 107.295 12.5524 107.373 12.5055C107.59 12.3798 107.791 12.3117 107.978 12.2949"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M105.898 15.8395L104.589 14.2615M105.936 11.9228L107.968 12.2971"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M106.722 16.5085C106.446 16.3465 106.28 15.9963 106.284 15.501C106.286 15.4261 106.288 15.3512 106.296 15.28M107.67 12.9235C107.732 12.8755 107.796 12.8374 107.864 12.7931C108.295 12.5481 108.682 12.5218 108.958 12.6838"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M128.288 24.0254L123.695 21.3305M108.747 17.5107L107.429 15.9191M108.789 13.5877L110.821 13.962"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M118.873 18.5201L119.312 17.7734"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M100.173 10.1032C100.092 10.2412 100.139 10.4205 100.277 10.5015L114.513 18.8547C114.651 18.9357 114.83 18.889 114.911 18.751C114.992 18.613 114.946 18.4337 114.808 18.3527L100.571 9.99948C100.433 9.91849 100.254 9.96518 100.173 10.1032Z"
      fill="#6B7073"
    />
    <path
      d="M121.441 25.1452C121.165 24.9832 114.386 20.7528 114.396 20.2611C114.398 20.1862 114.403 20.1051 114.409 20.0239L99.7019 11.3945M123.683 21.3242C123.407 21.1622 116.407 17.3082 115.983 17.5569C115.918 17.595 115.85 17.6393 115.782 17.6836L101.075 9.05425"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M116.294 16.5079C115.285 16.4728 113.986 16.3596 111.743 15.2799L112.442 15.7409C113.967 16.6355 116.103 16.8766 116.103 16.8766L123.688 21.3275L128.683 23.2797L128.947 23.4344L128.509 24.181C128.711 24.3674 128.824 24.6782 128.819 25.0888C128.812 25.5904 128.631 26.1423 128.348 26.6255C128.064 27.1086 127.667 27.5417 127.236 27.7867C126.877 27.9973 126.548 28.0404 126.292 27.9581L125.854 28.7047L125.591 28.5501L121.45 25.1422L113.865 20.6913C113.865 20.6913 112.606 18.9407 111.088 18.0498L110.379 17.6338C110.379 17.6338 110.351 17.6515 110.338 17.6604C112.384 19.0889 113.113 20.1746 113.636 21.0379C114.249 21.9626 113.166 22.3987 112.895 21.9272C112.353 20.9094 111.722 19.7292 109.071 17.8787C108.933 17.7977 108.821 17.6727 108.744 17.5013L108.378 16.8312C107.987 17.0234 106.975 16.6491 106.718 16.4981L106.229 16.211C106.091 16.13 105.978 16.005 105.902 15.8336L104.848 14.726C104.446 14.9371 104.083 14.9519 103.819 14.7973L103.33 14.5101C103.192 14.4291 103.08 14.3042 103.003 14.1328L101.949 13.0252C101.547 13.2362 101.184 13.2511 100.921 13.0964L100.431 12.8093C100.293 12.7283 100.178 12.5934 100.102 12.422L99.513 11.1402C99.4708 11.0395 99.4497 10.9175 99.4495 10.774C99.4503 10.4708 99.5642 10.1328 99.741 9.83165C99.9177 9.53049 100.157 9.26614 100.421 9.11757C100.547 9.04773 100.664 9.00669 100.772 8.9944L102.178 8.88329C102.365 8.86648 102.529 8.90358 102.673 8.98825L103.163 9.2754C103.426 9.43003 103.59 9.75404 103.609 10.2117L105.09 10.5915C105.277 10.5747 105.44 10.6118 105.578 10.6928L106.068 10.9799C106.331 11.1345 106.495 11.4586 106.507 11.9126L107.988 12.2923C108.175 12.2755 108.339 12.3126 108.477 12.3936L108.966 12.6808C109.224 12.8317 110.048 13.5261 110.067 13.9675L110.821 13.9626C111.008 13.9458 111.171 13.9829 111.316 14.0676C114.224 15.4789 115.559 15.4608 116.715 15.4308C117.256 15.428 117.4 16.5919 116.3 16.5116L116.294 16.5079Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M90.8133 72.2495C89.6607 72.2733 88.3222 72.2976 85.4176 70.8801C85.2795 70.7991 85.1058 70.7646 84.9251 70.7851L84.1715 70.79C84.1486 70.3548 83.3282 69.6541 83.071 69.5032L82.5816 69.216C82.4436 69.135 82.2761 69.1042 82.0928 69.1147L80.6119 68.735C80.5999 68.281 80.4358 67.957 80.1723 67.8023L79.6829 67.5152C79.5449 67.4342 79.3774 67.4034 79.1941 67.4139L77.7132 67.0342C77.7013 66.5802 77.5371 66.2561 77.2736 66.1015L76.7842 65.8144C76.6462 65.7334 76.4724 65.6989 76.2917 65.7194L74.8855 65.8304C74.7771 65.8427 74.6602 65.8838 74.5348 65.9536C74.2705 66.1022 74.0311 66.3666 73.8544 66.6677C73.6777 66.9689 73.5674 67.3006 73.5629 67.6101C73.5631 67.7535 73.5842 67.8756 73.6264 67.9763L74.2154 69.258C74.2919 69.4295 74.4005 69.5606 74.5448 69.6453L75.0342 69.9325C75.2977 70.0871 75.6606 70.0723 76.0628 69.8613L77.1167 70.9688C77.1932 71.1403 77.3055 71.2652 77.4435 71.3461L77.9329 71.6333C78.1964 71.7879 78.5593 71.7731 78.9615 71.5621L80.0154 72.6697C80.0919 72.8411 80.2042 72.966 80.3422 73.047L80.8316 73.3341C81.0888 73.4851 82.0969 73.8657 82.4917 73.6672L82.8576 74.3374C82.9341 74.5088 83.0464 74.6337 83.1844 74.7147C85.8351 76.5652 86.4704 77.7392 87.0118 78.757C87.2735 79.231 88.3596 78.7887 87.753 77.8677C87.2305 77.0044 86.4975 75.9249 84.4511 74.4964C84.4585 74.4839 84.4784 74.4787 84.4921 74.4698L85.2011 74.8858C86.7257 75.7804 87.9816 77.5211 87.9816 77.5211L95.5609 81.9683L99.6952 85.3725L99.9588 85.5272L100.397 84.7805C100.658 84.8665 100.985 84.8135 101.341 84.6091C101.771 84.3641 102.165 83.9373 102.452 83.4479C102.74 82.9585 102.92 82.4065 102.924 81.9111C102.929 81.5006 102.81 81.1861 102.613 81.0034L103.051 80.2568L102.788 80.1022L97.7992 78.1536L90.22 73.7063C90.22 73.7063 88.0878 73.459 86.5632 72.5644L85.8637 72.1034C88.1026 73.1894 89.4026 73.3026 90.411 73.3377C91.5172 73.4217 91.3699 72.264 90.8258 72.2569L90.8133 72.2495Z"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M75.7565 67.4369L75.7676 67.4181C75.7676 67.4181 75.7602 67.4306 75.7565 67.4369L88.9136 75.157C89.0516 75.238 89.1046 75.4208 89.0236 75.5589C88.9426 75.6969 88.7634 75.7436 88.6191 75.6589L75.462 67.9389C75.462 67.9389 75.4583 67.9451 75.4546 67.9514L75.462 67.9389L74.3828 67.3056C74.2448 67.2246 74.1981 67.0454 74.2791 66.9074C74.3601 66.7694 74.5393 66.7227 74.6773 66.8037L75.7502 67.4332L75.7565 67.4369ZM90.8213 72.2363C89.6651 72.2663 88.3303 72.2844 85.4219 70.8731C85.2839 70.7921 85.1102 70.7576 84.9294 70.7781L84.1759 70.783C84.1566 70.3415 83.3326 69.6471 83.0754 69.4962L82.586 69.209C82.4479 69.1281 82.2841 69.091 82.0972 69.1078L80.61 68.7243C80.6017 68.264 80.4376 67.94 80.1741 67.7854L79.6784 67.4946C79.5404 67.4136 79.3766 67.3765 79.1896 67.3933L77.7024 67.0099C77.6942 66.5496 77.53 66.2255 77.2602 66.0672L76.7708 65.7801C76.6328 65.6991 76.4627 65.6584 76.272 65.6814L74.8658 65.7925C74.7574 65.8048 74.6405 65.8459 74.5152 65.9157C74.2509 66.0643 74.0114 66.3286 73.8347 66.6298C73.658 66.931 73.5441 67.2689 73.5433 67.5721C73.5434 67.7156 73.5646 67.8376 73.6067 67.9383L74.1957 69.2201C74.2722 69.3915 74.3808 69.5227 74.5251 69.6074L75.0145 69.8945C75.278 70.0492 75.641 70.0344 76.0531 69.8208L77.1133 70.932C77.1898 71.1034 77.302 71.2283 77.4401 71.3093L77.9357 71.6002C78.1993 71.7548 78.5622 71.74 78.968 71.5227L80.0282 72.6339C80.1047 72.8053 80.217 72.9302 80.355 73.0112L80.8444 73.2984C81.1016 73.4493 82.1134 73.8237 82.5045 73.6315L82.8704 74.3016C82.9469 74.4731 83.0592 74.5979 83.1972 74.6789C85.8479 76.5294 86.4832 77.7035 87.021 78.7275C87.2826 79.2016 88.3687 78.7592 87.7621 77.8382C87.2396 76.9749 86.5103 75.8891 84.4639 74.4607C84.4713 74.4481 84.4912 74.4429 84.5049 74.4341L85.2138 74.8501C86.7385 75.7447 87.9908 77.4916 87.9908 77.4916L95.5763 81.9425L99.7169 85.3504L99.9867 85.5087L100.425 84.7621C100.686 84.8481 101.013 84.795 101.373 84.5844C101.807 84.3331 102.201 83.9063 102.488 83.4169C102.775 82.9275 102.955 82.3755 102.963 81.8739C102.971 81.4571 102.849 81.1489 102.652 80.9661L103.09 80.2195L102.82 80.0612L97.8257 78.1089L90.2401 73.658C90.2401 73.658 88.098 73.4133 86.5797 72.5224L85.8802 72.0613C88.1254 73.151 89.4227 73.2543 90.4374 73.293C91.5437 73.377 91.4 72.2131 90.8523 72.2123"
      fill="white"
    />
    <path
      d="M74.3845 67.3158C74.2465 67.2348 74.1998 67.0556 74.2808 66.9175C74.3618 66.7795 74.541 66.7328 74.6791 66.8138L75.752 67.4434L75.4538 67.9516L74.3809 67.322L74.3845 67.3158Z"
      fill="white"
    />
    <path
      d="M100.124 84.627L95.5313 81.9321"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M90.748 79.125L90.31 79.8716"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M75.0068 69.9065C74.7307 69.7445 74.5651 69.3943 74.569 68.899C74.5681 68.8142 74.5736 68.733 74.5853 68.6555M75.992 66.3012C76.0466 66.2657 76.1012 66.2302 76.152 66.201C76.5826 65.956 76.9691 65.9298 77.2451 66.0918"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M75.7663 67.4167C75.7273 67.5119 75.6784 67.6097 75.6269 67.6975C75.5753 67.7854 75.5201 67.8795 75.4497 67.9563"
      fill="#6B7073"
    />
    <path
      d="M101.385 81.5719C101.68 81.3993 101.949 81.3879 102.137 81.4984C102.325 81.6088 102.446 81.8485 102.439 82.1904C102.433 82.5323 102.313 82.909 102.114 83.2478C101.915 83.5866 101.645 83.875 101.35 84.0475C101.054 84.2201 100.786 84.2315 100.598 84.1211C100.41 84.0106 100.289 83.771 100.295 83.4291C100.302 83.0871 100.422 82.7104 100.621 82.3716C100.819 82.0328 101.084 81.7408 101.385 81.5719ZM101.391 81.0017C101.821 80.7567 102.208 80.7304 102.484 80.8924C102.76 81.0544 102.926 81.4046 102.922 81.9C102.918 82.3953 102.737 82.9473 102.45 83.4367C102.163 83.926 101.769 84.3529 101.339 84.5979C100.904 84.8492 100.522 84.8691 100.246 84.7071C99.9695 84.5452 99.7976 84.1913 99.8077 83.6996C99.8179 83.2079 99.9921 82.6523 100.279 82.1629C100.566 81.6735 100.96 81.2467 101.391 81.0017Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M77.0959 70.946C77.0193 70.7746 76.9748 70.5629 76.9786 70.3121C76.9815 70.221 76.988 70.1236 77.0045 70.0236M78.398 67.7206C78.4525 67.6851 78.5108 67.6434 78.5617 67.6142C78.7788 67.4885 78.9852 67.4241 79.1722 67.4073M74.1846 69.2378C74.1081 69.0664 74.0699 68.8584 74.07 68.6138C74.0728 68.5227 74.0793 68.4253 74.0896 68.3217M75.4248 66.0604C75.5004 66.0035 75.5822 65.9503 75.6604 65.9034C75.8775 65.7778 76.0777 65.7096 76.2646 65.6928M84.4565 74.4721C84.3946 74.5201 84.3301 74.5582 84.2656 74.5962C83.8351 74.8412 83.4486 74.8675 83.1662 74.7018M83.1699 74.6955C82.8938 74.5336 82.7219 74.1797 82.7258 73.6843C82.7287 73.5932 82.7378 73.5058 82.7469 73.4184M84.1179 71.1105C84.1798 71.0625 84.248 71.0182 84.3188 70.9838C84.753 70.7325 85.1359 70.7126 85.4182 70.8782M85.4119 70.8745C85.688 71.0365 85.8599 71.3904 85.856 71.8858C85.8527 71.9345 85.8557 71.9868 85.8525 72.0355"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M77.0883 70.9432L75.779 69.3653M77.1485 67.0313L79.1709 67.4082"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M77.9113 71.6101C77.6352 71.4481 77.4696 71.0979 77.4735 70.6025C77.4753 70.5277 77.4807 70.4465 77.4862 70.3653M78.8829 68.0136C78.9412 67.9718 78.9994 67.9301 79.0602 67.8983C79.4907 67.6533 79.8773 67.6271 80.1533 67.7891"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M80 72.6504C79.9235 72.479 79.8853 72.271 79.8891 72.0202C79.8919 71.9291 79.8948 71.838 79.9076 71.7443M81.2539 69.4641C81.3258 69.4135 81.3976 69.363 81.4758 69.316C81.6929 69.1904 81.8931 69.1223 82.0801 69.1055"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M79.9998 72.65L78.6906 71.0721M80.0376 68.7333L82.0699 69.1076"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M80.8234 73.319C80.5474 73.1571 80.3817 72.8069 80.3856 72.3115C80.3874 72.2366 80.3891 72.1618 80.3972 72.0906M81.7715 69.734C81.8334 69.686 81.8978 69.648 81.966 69.6036C82.3966 69.3586 82.7831 69.3324 83.0591 69.4944"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M102.39 80.8359L97.7969 78.1411M82.849 74.3212L81.5309 72.7297M82.8904 70.3983L84.9227 70.7726"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M92.975 75.3306L93.4131 74.584"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M74.2747 66.9138C74.1937 67.0518 74.2404 67.231 74.3784 67.312L88.6147 75.6653C88.7527 75.7463 88.9319 75.6996 89.0129 75.5615C89.0939 75.4235 89.0472 75.2443 88.9092 75.1633L74.6729 66.81C74.5349 66.729 74.3557 66.7757 74.2747 66.9138Z"
      fill="#6B7073"
    />
    <path
      d="M95.5432 81.9558C95.2671 81.7938 88.4884 77.5633 88.4986 77.0716C88.5003 76.9968 88.5058 76.9156 88.5112 76.8345L73.8044 68.2051M97.7852 78.1348C97.5091 77.9728 90.5095 74.1188 90.0853 74.3675C90.0208 74.4055 89.9526 74.4498 89.8844 74.4942L75.1776 65.8648"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M90.3954 73.3184C89.387 73.2834 88.0871 73.1701 85.8445 72.0904L86.5439 72.5514C88.0686 73.446 90.2044 73.6871 90.2044 73.6871L97.79 78.138L102.785 80.0903L103.048 80.2449L102.61 80.9915C102.813 81.1779 102.926 81.4888 102.921 81.8993C102.913 82.4009 102.733 82.9529 102.449 83.436C102.166 83.9191 101.768 84.3522 101.338 84.5972C100.978 84.8078 100.649 84.851 100.394 84.7686L99.9557 85.5153L99.6922 85.3607L95.5516 81.9528L87.9661 77.5019C87.9661 77.5019 86.7075 75.7513 85.1892 74.8603L84.4802 74.4443C84.4802 74.4443 84.4529 74.4621 84.4393 74.4709C86.4857 75.8994 87.2149 76.9852 87.7374 77.8484C88.3503 78.7732 87.2679 79.2092 86.9963 78.7378C86.4548 77.72 85.8232 76.5397 83.1725 74.6892C83.0345 74.6082 82.9223 74.4833 82.8457 74.3119L82.4798 73.6417C82.0887 73.834 81.0769 73.4596 80.8197 73.3087L80.3303 73.0215C80.1923 72.9405 80.08 72.8156 80.0035 72.6442L78.9496 71.5366C78.5474 71.7476 78.1845 71.7624 77.921 71.6078L77.4316 71.3207C77.2936 71.2397 77.1813 71.1147 77.1048 70.9433L76.0509 69.8357C75.6488 70.0468 75.2858 70.0616 75.0223 69.907L74.5329 69.6198C74.3949 69.5388 74.28 69.4039 74.2035 69.2325L73.6145 67.9507C73.5724 67.8501 73.5512 67.728 73.5511 67.5845C73.5518 67.2813 73.6658 66.9434 73.8425 66.6422C74.0192 66.341 74.2587 66.0767 74.523 65.9281C74.6483 65.8583 74.7652 65.8172 74.8736 65.8049L76.2799 65.6938C76.4668 65.677 76.6306 65.7141 76.7749 65.7988L77.2643 66.086C77.5279 66.2406 77.692 66.5646 77.7102 67.0223L79.1911 67.402C79.3781 67.3852 79.5419 67.4223 79.6799 67.5033L80.1693 67.7905C80.4328 67.9451 80.5969 68.2691 80.6089 68.7231L82.0898 69.1029C82.2768 69.0861 82.4406 69.1232 82.5786 69.2042L83.068 69.4913C83.3253 69.6423 84.1492 70.3366 84.1685 70.7781L84.9221 70.7732C85.1091 70.7564 85.2729 70.7935 85.4172 70.8781C88.3255 72.2894 89.6603 72.2714 90.8166 72.2413C91.358 72.2385 91.5017 73.4024 90.4017 73.3221L90.3954 73.3184Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      opacity={0.4}
      d="M236.874 93.3329C238.064 94.0331 239.597 93.636 240.297 92.4461C240.997 91.2561 240.6 89.7238 239.41 89.0236L238.142 91.1782L236.874 93.3329ZM238.142 91.1782L239.41 89.0236C228.103 82.3702 215.533 74.9737 202.652 67.3942L201.384 69.5488L200.116 71.7035C212.997 79.283 225.567 86.6795 236.874 93.3329L238.142 91.1782Z"
      fill="#BABEC3"
    />
    <path
      opacity={0.4}
      d="M210.973 150.143C212.163 150.843 213.696 150.446 214.396 149.256C215.096 148.066 214.699 146.534 213.509 145.833L212.241 147.988L210.973 150.143ZM212.241 147.988L213.509 145.833C186.195 129.761 164.656 117.087 143.333 104.541L142.065 106.695L140.798 108.85C162.12 121.397 183.659 134.071 210.973 150.143L212.241 147.988Z"
      fill="#BABEC3"
    />
    <path
      d="M192.191 100.127C192.191 100.127 187.589 94.3529 185.421 90.3712C183.717 87.2438 185.905 83.4748 181.836 82.1401C179.691 81.4366 178.108 81.6572 175.862 82.1401C168.84 83.6494 171.86 95.5484 172.24 96.9444C172.265 97.0356 172.277 97.1259 172.277 97.2204V100.127M170.684 105.004C170.831 98.6991 171.056 89.0508 171.08 88.022C171.082 87.9587 171.088 87.9028 171.104 87.8414C171.227 87.3584 171.88 85.1077 173.472 84.8838C175.127 84.651 177.056 85.1886 177.056 87.0177C177.056 93.2553 180.18 100.066 181.836 102.261M178.65 103.175C178.65 103.175 176.666 101.247 175.862 99.8217C174.491 97.3953 174.667 95.7583 174.667 93.1149C174.667 91.5906 174.477 89.5204 172.277 88.8469C171.122 88.4932 170.306 88.6433 169.091 88.8469C163.612 89.7646 168.345 95.5293 168.294 99.8217C168.284 100.655 168.294 101.956 168.294 101.956M170.286 101.041C170.286 101.041 169.185 96.3716 167.154 93.7932C167.118 93.747 167.084 93.6972 167.056 93.646C165.535 90.9448 163.669 91.0808 162.822 91.531C162.751 91.5684 162.688 91.6202 162.635 91.6796C160.932 93.5822 163.668 95.9934 164.311 98.2974C164.856 100.249 166.303 103.175 166.303 103.175M165.506 105.919C165.506 105.919 164.093 99.1102 161.523 95.2488C157.142 88.8469 151.765 88.0653 156.345 95.5537C158.53 99.1248 162.718 104.395 162.718 104.395"
      stroke="#6B7073"
      strokeWidth={0.5}
    />
    <rect
      x={79.999}
      y={47}
      width={17.2584}
      height={17.2584}
      rx={8.62918}
      fill="#01B5DE"
    />
    <path
      d="M90.3185 58.6289H89.3585V57.0889H86.0985V56.2089L89.4185 51.6289H90.3185V56.2089H91.1585V57.0889H90.3185V58.6289ZM89.3585 53.1389L87.1185 56.2089H89.3585V53.1389Z"
      fill="white"
    />
    <rect
      x={221.013}
      y={131}
      width={17.2584}
      height={17.2584}
      rx={8.62918}
      fill="#01B5DE"
    />
    <path
      d="M229.559 142.729C229.099 142.729 228.682 142.632 228.309 142.439C227.936 142.246 227.636 141.976 227.409 141.629C227.189 141.282 227.066 140.886 227.039 140.439H227.999C228.046 140.832 228.202 141.166 228.469 141.439C228.736 141.712 229.099 141.849 229.559 141.849C230.052 141.849 230.442 141.699 230.729 141.399C231.022 141.099 231.169 140.682 231.169 140.149C231.169 139.622 231.022 139.216 230.729 138.929C230.442 138.636 230.079 138.489 229.639 138.489C229.246 138.489 228.916 138.546 228.649 138.659C228.389 138.766 228.146 138.899 227.919 139.059L227.229 138.729L227.669 135.629H231.609V136.509H228.399L228.109 138.179C228.322 138.032 228.576 137.912 228.869 137.819C229.162 137.726 229.462 137.679 229.769 137.679C230.496 137.679 231.072 137.899 231.499 138.339C231.932 138.772 232.149 139.366 232.149 140.119C232.149 140.586 232.046 141.019 231.839 141.419C231.632 141.812 231.332 142.129 230.939 142.369C230.546 142.609 230.086 142.729 229.559 142.729Z"
      fill="white"
    />
  </svg>
)

export default IgMountBase
